<template>
  <div class="payment-page">
    <h1>Payment Details</h1>
    <fieldset v-if="!checkoutInitiated">
      <legend>Personal Information</legend>
      <div class="input-group">
        <label for="email">Email:</label>
        <input id="email" v-model="userData.email" placeholder="Enter your email" />
      </div>
      <div class="input-group">
        <label for="firstName">First Name:</label>
        <input id="firstName" v-model="userData.firstName" placeholder="Enter your first name" />
      </div>
      <div class="input-group">
        <label for="lastName">Last Name:</label>
        <input id="lastName" v-model="userData.lastName" placeholder="Enter your last name" />
      </div>
      <div class="input-group">
        <label for="birthDate">Birth Date:</label>
        <input id="birthDate" type="date" v-model="userData.birthDate" placeholder="Enter your birth date" />
      </div>
      <div class="input-group">
        <label for="birthCity">Birth City:</label>
        <input id="birthCity" v-model="userData.birthCity" placeholder="Enter your birth city" />
      </div>
      <div class="action-buttons">
        <button @click="handleSubmit" class="submit-button">Submit</button>
      </div>
    </fieldset>

    <fieldset v-if="checkoutInitiated">
      <legend>Payment Information</legend>
      <div id="checkout"></div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { STRIPE_INIT_CHECKOUT } from "@/store/actions";

import { loadStripe } from "@stripe/stripe-js";

export default {
  name: "NumerologyPaymentPage",
  props: ['amount', 'firstName', 'lastName', 'birthday'],
  data() {
    return {
      stripe: null,
      checkout: null,
      userData: {
        firstName: "",
        lastName: "",
        birthDate: "",
        birthCity: "",
        email: "",
      },
      price: 'full',
      paymentData: {
        payment_method_types: ["card"],
        ui_mode: "embedded",
        line_items: [
          {
            price_data: {
              currency: "eur",
              product_data: {
                name: "Numerology Report",
              },
            },
            quantity: 1,
          },
        ],
        mode: "payment",
        return_url: "https://jeanluc-ai.web.app/numerology/payment/success",
      },
      checkoutInitiated: false,
    };
  },
  created() {
    if (this.$route.params) {
      const { firstName, lastName, birthday, email, amount } = this.$route.params;
      this.userData.firstName = firstName || this.userData.firstName;
      this.userData.lastName = lastName || this.userData.lastName;
      this.userData.birthDate = birthday || this.userData.birthDate;
      this.userData.email = email || this.userData.email;
      this.price = amount || this.price;
    }
  },
  beforeDestroy() {
    if (this.checkout) {
      this.checkout.destroy();
    }
  },
  methods: {
    ...mapActions("checkout", { initCheckout: STRIPE_INIT_CHECKOUT }),
    handleSubmit() {
      this.initiateCheckout();
    },
    isUserDataComplete(data) {
      return data.firstName && data.lastName && data.birthDate && data.birthCity && data.email;
    },
    async initiateCheckout() {
      this.checkoutInitiated = true;
      const stripePublicKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY;
      this.stripe = await loadStripe(stripePublicKey);

      const queryParams = new URLSearchParams(this.userData).toString();

      try {
        const { clientSecret } = await this.initCheckout({paymentData: this.paymentData, price: this.price, queryParams });
        this.checkout = await this.stripe.initEmbeddedCheckout({ clientSecret });
        this.checkout.mount("#checkout");
      } catch (error) {
        console.error("Error initializing Stripe checkout:", error);
      }
    },
  },
};
</script>

<style scoped>
.payment-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #ffffff87;
}

fieldset {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

legend {
  padding: 0 5px;
  font-weight: bold;
  color: #333;
}

.input-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #555;
}

input,
select,
#checkout {
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  padding: 10px 20px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.action-buttons {
  text-align: right;
}

.cancel-button {
  background-color: #ff6b6b;
  float: left;
}

.submit-button {
  background-color: #027015;
  float: right;
}

.error input {
  border-color: red;
}

.error p {
  color: red;
  font-size: 12px;
}
</style>
